import React from 'react'
import './Regata.scss'

function Regata() {
  return (
    <div>Regata</div>
  )
}

export default Regata
